<template>
  <b-row>
    <b-col>
      <h1>External resources</h1>
      <ul>
        <li>
          <a href="https://restorationgames.com/unmatched/" target="_blank"
            >Restoration Games</a
          >
          <ul>
            <li>
              <a href="https://discord.gg/j4k8VWv" target="_blank">
                Discord
              </a>
            </li>
            <li>
              <a href="https://twitter.com/restorationgame" target="_blank">
                Twitter
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/restorationgames/"
                target="_blank"
              >
                YouTube
              </a>
              - Includes archived video of deck design seminar
            </li>
            <li>
              <a href="https://www.twitch.tv/restorationgames" target="_blank">
                Twitch
              </a>
              - Includes archived video of deck design seminar
            </li>
          </ul>
        </li>
        <li>
          <a href="https://mondoshop.com/collections/unmatched" target="_blank"
            >Mondo Games</a
          >
          <ul>
            <li>
              <a href="https://twitter.com/mondonews" target="_blank"
                >Twitter</a
              >
            </li>
          </ul>
        </li>
        <li>
          BoardGameGeek pages
          <ul>
            <li>
              <a
                href="https://boardgamegeek.com/boardgamefamily/56937/game-unmatched"
                target="_blank"
              >
                Unmatched game page
              </a>
              - Has links to other games in system
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/295564/unmatched-game-system"
                target="_blank"
              >
                Unmatched game system page
              </a>
              - Doesn't get much traffic
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/274637/unmatched-battle-legends-volume-one"
                target="_blank"
              >
                Battle of Legends, Volume One
              </a>
              - Hosts a lot of general discussion
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/274638/unmatched-robin-hood-vs-bigfoot"
                target="_blank"
              >
                Robin Hood vs. Bigfoot
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgameexpansion/279645/unmatched-bruce-lee"
                target="_blank"
              >
                Bruce Lee
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/284777/unmatched-jurassic-park-ingen-vs-raptors"
                target="_blank"
              >
                Jurassic Park: InGen vs. Raptors
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/294484/unmatched-cobble-fog"
                target="_blank"
              >
                Cobble & Fog
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/315060/unmatched-buffy-vampire-slayer"
                target="_blank"
              >
                Buffy the Vampire Slayer
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgame/284778/unmatched-jurassic-park-sattler-vs-t-rex"
                target="_blank"
              >
                Jurassic Park: Sattler vs. T. rex
              </a>
            </li>
            <li>
              <a
                href="https://boardgamegeek.com/boardgameexpansion/284779/unmatched-jurassic-park-grant"
                target="_blank"
              >
                Jurassic Park: Grant
              </a>
              - listed as cancelled, but may be revived in some form
            </li>
          </ul>
        </li>
        <li>
          <a
            href="https://www.geektopiagames.com/games/unmatched/"
            target="_blank"
          >
            Geektopia Games' Unmatched page
          </a>
          - filled with deck lists, breakdowns, and great design analysis
        </li>
        <li>
          <a
            href="https://docs.google.com/spreadsheets/d/1BOdYOeTDW0ddVBq4Oq_CWADMzIonOcBjvDRpWHuUs50/edit#gid=2027579905"
            target="_blank"
          >
            Win/loss tracker
          </a>
          <ul>
            <li>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScKU4QmkKy3wy26omcov0jtDU5ORb89EeqUlbv9DTjq1X2bMA/viewform"
                target="_blank"
              >
                Submission form
              </a>
            </li>
            <li>
              <a
                href="https://docs.google.com/spreadsheets/d/1crlxChy5ysDBRSdlWVD6Ri8qtsVH2dfZ6jv2B3bT3Bs/edit?usp=sharing"
                target="_blank"
              >
                Alternate visualization
              </a>
              by @FloMoTion on Discord
            </li>
          </ul>
        </li>
        <li>
          <a
            href="https://docs.google.com/spreadsheets/d/1c5wa40gfimLr-LOOomeHZFOwDPa3SWh4VXsXi8PzvE8/edit?usp=sharing"
            target="_blank"
          >
            Deck comparison tool
          </a>
          <ul>
            <li>
              <a
                href="https://boardgamegeek.com/thread/2431198/deck-comparison-tool"
                target="_blank"
              >
                BoardGameGeek thread with discussion
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="https://unbrewed.xyz/" target="_blank">
            Unbrewed
          </a>
          - tools for playtesting fan decks
        </li>
      </ul>
    </b-col>
  </b-row>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Resources",
  metaInfo: {
    title: "Resources"
  },
  components: {}
};
</script>
